import React, { useState, useEffect, useContext } from "react";
import { UserContext } from "../UserContext";
import { Box, Typography, Grid } from "@mui/material";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { ProgressLabel } from "./elements/ProgressLabel";
import Button from "./elements/Button";
import LinearScaleIcon from '@mui/icons-material/LinearScale';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import { FaSpinner } from "react-fontawesome";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { CreateActivityPopup } from "./CreateActivityPopup";



export const Itinerary = () => {
    const { user } = useContext(UserContext);
    const [liked, setLiked] = useState(false);
    const [disliked, setDisLiked] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const [error, setError] = useState(null);
    const [popupOpen, setPopupOpen] = useState(false);

    // useEffect(() => {
    //     if (!user) {
    //         window.location.href="/login";
    //     }
    // }, [user]);

    const handleLikeUnlike = async () => {
        setError(null);
        setIsFetching(true);
        try {
            const response = await fetch(
                "",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        action: liked ? "unlike" : "like",
                    }),
                }
            );

            if (response.status >= 200 && response.status < 300) {
                setLiked(!liked);
            } else {
                const res = await response.json();
                setError(res.message);
                return;
            }
        } finally {
            setIsFetching(false);
        }
    };

    const handlePopupOpen = () => {
        setPopupOpen(true);
    };

    const handlePopupClose = () => {
        setPopupOpen(false);
    };

    return (
        <Box
            maxWidth="xl"
            sx={{
                display: "block",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
            }}
            className="mt-10 banner md:pl-32"
        >
            <Grid container spacing={2} display="block">
                <Grid item xs={12} sm={6}>
                    <Box maxWidth="sm" display="grid" margin="10px">
                        <Typography
                            variant="h5" 
                            className="trips md:text-2xl sm:text-sm trp pl-14"
                            sx={{
                                marginTop: "-3%",
                                fontWeight: "500"
                            }}
                        >
                            New York
                        </Typography>
                        <span className="inline mt-[-1%] pl-14">
                            <CalendarMonthIcon 
                                className="text-gray-500 inline"
                            />{" "}
                            <Typography
                                variant="h6"
                                className="text-gray-500 inline"
                                sx={{
                                    fontSize: "12px",
                                }}            
                            >
                                March 10 - 12
                            </Typography>
                        </span>
                        <Box className="pl-14">
                            <span>
                                <img src={require("../assets/images/1.png")} alt="avatar" className="inline" style={{ marginRight: '-5px' }} width="8%" />
                                <img src={require("../assets/images/2.png")} alt="avatar" className="inline" style={{ marginRight: '-5px' }} width="8%"/>
                                <img src={require("../assets/images/3.png")} alt="avatar" className="inline" style={{ marginRight: '-5px' }} width="8%" />
                                <img src={require("../assets/images/4.png")} alt="avatar" className="inline"style={{ marginRight: '-5px' }}  width="8%" />
                                <img src={require("../assets/images/anonymous.png")} alt="avatar" className="inline" width="8%" />
                            </span>
                        </Box>
                    </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Box maxWidth="sm" display="grid" margin="10px">
                    <Typography 
                        variant="h6" 
                        className="text-black pl-14" 
                        sx={{
                            fontSize: "14px",
                            marginTop: "3%",
                            marginBottom: "2%"
                        }}
                    >
                        Budget
                    </Typography>
                    <Box maxWidth="sm" className="w-3/5 border border-r shadow shadow-2 rounded-xl ml-14">
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                            }}
                        >
                        <Typography 
                        variant="h6" 
                        className="text-gray-600 pl-3"
                        sx={{
                            fontSize: "14px",
                            marginBottom: "2%"
                        }}
                        >
                            Planned Activities
                        </Typography>

                        <Typography 
                        variant="h6" 
                        className="text-gray-600 pr-3"
                        sx={{
                            fontSize: "14px",
                            marginBottom: "2%"
                        }}
                        >
                            Edit
                        </Typography>
                        </Box>
                        <Box>
                            <Typography
                            variant="h5" 
                            className="md:text-2xl sm:text-sm trp pl-3"
                            sx={{
                                fontWeight: "500"
                            }}
                            >
                            $25
                            </Typography>
                            <ProgressLabel />
                        </Box>
                    </Box></Box>
                </Grid>
            </Grid>
            
            <Box maxWidth="sm" margin="10px">
                <Typography 
                    variant="h6" 
                    className="text-black pl-14" 
                    sx={{
                        fontSize: "14px",
                        marginTop: "3%",
                        marginBottom: "2%"
                    }}
                >
                    Itinerary
                </Typography>
                <Box className="space-x-4 pl-14"
                    display="flex" 
                    sx={{
                        marginTop: "-6%"
                    }}
                >
                    <Button
                        className="rounded-xl md:px-14 py-5"
                        
                    >
                        Day 1
                    </Button>
                    <Button 
                        variant="outline"
                        className="border-gray-400 rounded-xl md:px-14 py-5"
                    >
                        Day 2
                    </Button>
                    <Button
                        variant="outline"
                        className="border-gray-400 rounded-xl md:px-14 py-5"
                    >
                        Day 3
                    </Button>
                </Box>
                <Box maxWidth="xl" display="flex" className="my-10">
                    <Box maxWidth="sm" marginRight="20px">
                        <img src={require("../assets/images/ellipse.png")} alt="" className="mt-8 md:px-6"/>
                    </Box>
                    <Box className="w-5/6 my-5 border border-r shadow shadow-2 rounded-xl">
                    <Box display="flex" justifyContent="space-between">
                    <Typography
                        variant="h5" 
                        className="md:text-2xl sm:text-sm text-pry pl-3"
                        sx={{
                            fontWeight: "500",
                            fontSize: "12px",
                            marginTop:"20px",
                            marginBottom: "10px"
                        }}
                        >
                        9:00 am
                    </Typography>
                    <LinearScaleIcon
                        className="md:text-2xl sm:text-sm text-pry trp pr-3"
                        sx={{
                            marginTop:"10px",
                            marginBottom: "10px",
                            color: "black"
                        }}
                    />
          
                    </Box>
                        <Typography
                        variant="h5" 
                        className="md:text-2xl sm:text-sm trp pl-3"
                        sx={{
                            fontWeight: "500",
                            fontSize: "18px"
                        }}
                        >
                        Museum of Modern Arts
                        </Typography>

                        <Box maxWidth="sm" display="grid" margin="10px">
                        <span className="inline mt-[2%] shadow bg-gray-50 rounded-xl w-fit">
                            <FmdGoodIcon 
                                className="text-gray-500 inline"
                                fontSize="small"
                            />
                            <Typography
                                variant="h5" 
                                className="text-gray-500 inline pr-2"
                                sx={{
                                    marginTop: "-3%",
                                    fontSize: "12px"
                                }}
                            >
                                Address: 11 W 53rd St, New York, NY 10019
                            </Typography>
                        </span>
                        <span className="inline mt-[2%] shadow bg-gray-50 w-fit rounded-xl">
                            <FmdGoodIcon 
                                className="text-gray-500 inline"
                                fontSize="small"
                            />
                            <Typography
                                variant="h5" 
                                className="text-gray-500 inline pr-2"
                                sx={{
                                    marginTop: "-3%",
                                    fontSize: "12px"
                                }}
                            >
                                Estimated cost: $25
                            </Typography>
                        </span>
                            <Typography
                                variant="h6"
                                className="text-gray-500 inline"
                                sx={{
                                    fontSize: "14px",
                                    marginTop: "20px"
                                }}            
                            >
                            Visible to everyone
                            </Typography>
                            <div className="mt-[-5%]">
                            <Button
                                variant="outline"
                                onClick={handleLikeUnlike}
                                className={`likeBtn ${liked ? "liked" : ""}`}
                            ><span>
                                <img src={require("../assets/images/like.png")} alt="" className="inline" /> {" "}
                            </span>
                                {isFetching ? <FaSpinner /> : <like />}
                                {liked ? "Liked" : "0"}
                            </Button>
                            {error && <div className="error">{error}</div>} {" "}

                            <Button
                                variant="outline"
                                onClick={handleLikeUnlike}
                                className={`dislikeBtn ${disliked ? "disliked" : ""}`}
                            ><span>
                                <img src={require("../assets/images/dislike.png")} alt="" className="inline" /> {" "}
                            </span>
                                {isFetching ? <FaSpinner /> : <like />}
                                {disliked ? "DisLiked" : "0"}
                            </Button>
                            {error && <div className="error">{error}</div>}
                        </div>
                        </Box>
                    <Box></Box></Box>
                </Box>
                <Box maxWidth="xl" display="flex" className="my-10">
                    <Box maxWidth="sm" marginRight="20px">
                        <img src={require("../assets/images/ellipse.png")} alt="" className="mt-8 md:px-6"/>
                    </Box>
                    <Box className="w-5/6 my-5 border border-r shadow shadow-2 rounded-xl">
                    <Box display="flex" justifyContent="space-between">
                    <Typography
                        variant="h5" 
                        className="md:text-2xl sm:text-sm text-pry pl-3"
                        sx={{
                            fontWeight: "500",
                            fontSize: "12px",
                            marginTop:"20px",
                            marginBottom: "10px"
                        }}
                        >
                        1:00 pm
                    </Typography>
                    <LinearScaleIcon
                        className="md:text-2xl sm:text-sm text-pry trp pr-3"
                        sx={{
                            marginTop:"10px",
                            marginBottom: "10px",
                            color: "black"
                        }}
                    />
          
                    </Box>
                        <Typography
                        variant="h5" 
                        className="md:text-2xl sm:text-sm trp pl-3"
                        sx={{
                            fontWeight: "500",
                            fontSize: "18px"
                        }}
                        >
                        Central Park
                        </Typography>

                        <Box maxWidth="sm" display="grid" margin="10px">
                        <span className="inline mt-[2%] shadow bg-gray-50 rounded-xl w-fit">
                            <FmdGoodIcon 
                                className="text-gray-500 inline"
                                fontSize="small"
                            />
                            <Typography
                                variant="h5" 
                                className="text-gray-500 inline pr-2"
                                sx={{
                                    marginTop: "-3%",
                                    fontSize: "12px"
                                }}
                            >
                                Address: New York, NY
                            </Typography>
                        </span>
                        <span className="inline mt-[2%] shadow bg-gray-50 w-fit rounded-xl">
                            <FmdGoodIcon 
                                className="text-gray-500 inline"
                                fontSize="small"
                            />
                            <Typography
                                variant="h5" 
                                className="text-gray-500 inline pr-2"
                                sx={{
                                    marginTop: "-3%",
                                    fontSize: "12px"
                                }}
                            >
                                Estimated cost: Free
                            </Typography>
                        </span>
                            <Typography
                                variant="h6"
                                className="text-gray-500 inline"
                                sx={{
                                    fontSize: "14px",
                                    marginTop: "20px"
                                }}            
                            >
                            Visible to everyone
                            </Typography>
                            <div className="mt-[-5%]">
                            <Button
                                variant="outline"
                                onClick={handleLikeUnlike}
                                className={`likeBtn ${liked ? "liked" : ""}`}
                            ><span>
                                <img src={require("../assets/images/like.png")} alt="" className="inline" /> {" "}
                            </span>
                                {isFetching ? <FaSpinner /> : <like />}
                                {liked ? "Liked" : "0"}
                            </Button>
                            {error && <div className="error">{error}</div>} {" "}

                            <Button
                                variant="outline"
                                onClick={handleLikeUnlike}
                                className={`dislikeBtn ${disliked ? "disliked" : ""}`}
                            ><span>
                                <img src={require("../assets/images/dislike.png")} alt="" className="inline" /> {" "}
                            </span>
                                {isFetching ? <FaSpinner /> : <like />}
                                {disliked ? "DisLiked" : "3"}
                            </Button>
                            {error && <div className="error">{error}</div>}
                        </div>
                        </Box>
                    <Box></Box></Box>
                </Box>      
                </Box>
            <Box
                sx={{
                    position: 'fixed',
                    bottom: '70px',
                    right: '70px',
                    cursor: 'pointer',
                    zIndex: '999' 
                }}
                onClick={handlePopupOpen}
            >
                <AddCircleIcon 
                    className="text-pry" 
                    sx={{
                        fontSize: 60
                    }}
                />
            </Box>
                <CreateActivityPopup open={popupOpen} onClose={handlePopupClose} />
        </Box>
    );
};
